export default __webpack_public_path__ + "static/media/Line 13.d5d957c7.svg";